/**
 * Returns offset from offset UTC offset to a local one
 */
export function getLocalOffsetFromUTCOffset(fromUTCOffset: number) {
	return fromUTCOffset + new Date().getTimezoneOffset() * 60 * 1000;
}
